import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from '../../../components/Component';
import { useParams } from 'react-router';
import PageHeading from '../components/page_heading/PageHeading';
import { Card, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown } from 'reactstrap';
import { employee_dashboard_actions_helper } from '../../../actions/actions_helper';
import { fail_user_account_details, loading_user_account_details, reset_user_account_details, success_user_account_details } from '../../../reducers/dashboard_reducers/user_accounts/user_account_details_Slice';
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RETRIEVE_SPECIFIC_USER_ACCOUNT_ACCESS_DENIED_MSG, RETRIEVE_SPECIFIC_USER_ACCOUNT_ERR_MSG, RETRIEVE_SPECIFIC_USER_ACCOUNT_SUCCESS_MSG, RETRIEVE_USER_ACCOUNTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_USER_ACCOUNTS_LIST_ERR_MSG, RETRIEVE_USER_ACCOUNTS_LIST_SUCCESS_MSG } from '../../../constants/success_error_messages_consts';
import { RETRIEVE_SPECIFIC_USER_ACCOUNT_DETAILS_API, RETRIEVE_USER_ACCOUNTS_LIST_EXCEPT_EMPLOYEES_API } from '../../../api/api_data';
import * as app_consts from "../../../constants/react_app_consts";
import CardTabs from '../components/cards/CardTabs';
import ProfileDetailText from '../components/text/ProfileDetailText';
import moment from 'moment';
import DocumentViewer from '../components/pdf/DocumentViewer';
import { ReadOnlyCompanyRepData } from '../components/table/table_components/read_only_row_data';
import ReadOnlyTable from '../components/table/ReadOnlyTable';
import ModalAdd from '../components/modal/modal_add/ModalAdd';
import { findModuleAction } from '../../../utils/functionalUtils';
import { Link } from 'react-router-dom';
import AuthLoader from '../../components/page_messaging/AuthLoader';
import AuthError from '../../components/page_messaging/AuthError';
import EditCompanyDetailsModal from '../components/modal/EditCompanyDetailsModal';

const initial_actions_data = { onboard_company: false, add_user_property: false };
const onboard_property_type = app_consts.ONBOARD_USER_PROPERTY;

const CompanyAccountDetails = () => {

    const { user_account } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [page_data, setPageData] = useState([]);
    const [activeCardTab, setActiveCardTab] = useState("Main Details");
    const dispatch = useDispatch();
    const [dataFetched, setDataFetched] = useState(false);
    const [open_add_properties_modal, setAddPropertiesModal] = useState(false);
    const [account_actions, setAccountActions] = useState([]);
    const [componentData, setComponentData] = useState(initial_actions_data);
    const [sm, updateSm] = useState(false);
    const [edit_company_details_modal, setEditCompanyDetailsModal] = useState(false);

    const open_edit_company_details_modal = () => {
        setEditCompanyDetailsModal(true);
    };

    const close_edit_company_details_modal = () => {
        setEditCompanyDetailsModal(false);
    };

    // On Page Load
    useEffect(() => {
        retrieve_user_account_details_func();
        if (localStorage.getItem("log_cred"))
        {
            setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
        }
    }, []);

    // Listen to Changes In Account Actions
    useEffect(() => {
        if (account_actions)
        {
            let actions_data = initial_actions_data;
            account_actions?.map((module) => {
                if (module.module_name === app_consts.ONBOARDING) 
                {
                    // Actions Data
                    if (findModuleAction(app_consts.ONBOARD_USER, module))
                    {
                        actions_data.create_loading_order = true;
                    }
                }
            });
            setComponentData(actions_data);
        }
    }, [account_actions]);

    // Listen to Changes In Account Actions
    useEffect(() => {
        if (account_actions)
        {
            let actions_data = initial_actions_data;
            account_actions?.map((module) => {
                if (module.module_name === app_consts.USER_MANAGEMENT) 
                {
                    if (findModuleAction(app_consts.AMEND_USER_STATUS, module))
                    {
                        actions_data.add_user_property = true;
                    }
                }

                if (module.module_name === app_consts.ONBOARDING) 
                {
                    if (findModuleAction(app_consts.ONBOARD_COMPANY, module))
                    {
                        actions_data.onboard_company = true;
                    }
                }
            });
            setComponentData(actions_data);
        }
    }, [account_actions]);

    // Retrieve User Account Details
    const retrieve_user_account_details_func = () => {
        dispatch(
            employee_dashboard_actions_helper(
                loading_user_account_details,
                success_user_account_details,
                fail_user_account_details,
                RETRIEVE_SPECIFIC_USER_ACCOUNT_ERR_MSG,
                RETRIEVE_SPECIFIC_USER_ACCOUNT_SUCCESS_MSG,
                app_consts.GET,
                `${RETRIEVE_SPECIFIC_USER_ACCOUNT_DETAILS_API}/${user_account}`,
                null,
                RETRIEVE_SPECIFIC_USER_ACCOUNT_ACCESS_DENIED_MSG
            )
        );
    };

    // Listen to User Account Details Reducer
    const specific_user_account_details = useSelector((state) => state.user_account_details.user_account_details);
    // 
    useEffect(() => {
        if (specific_user_account_details.status !== app_consts.IDLE)
        {
            if (specific_user_account_details.status === app_consts.LOADING)
            {
                setError("");
                setLoading(true);
            } else
            {
                setLoading(false);
                if (specific_user_account_details.status === app_consts.FAIL)
                {
                    setError(specific_user_account_details.message);
                    messageToast(specific_user_account_details.message, app_consts.FAIL);
                } else if (specific_user_account_details.status === app_consts.SUCCESS)
                {
                    setDataFetched(true);
                    setPageData(specific_user_account_details.data);
                }
                dispatch(reset_user_account_details());
            }
        }
    }, [specific_user_account_details]);

    // Card Tabs
    const tabs = [
        {
            tabName: "Main Details"
        },
        {
            tabName: "Main Contact Person"
        },
        // {
        //     tabName: "Representatives"
        // }
    ];

    // Modal Success Function
    const successAddPropertyFunc = (property_data = null) => {
        setAddPropertiesModal(false);
        setPageData({
            ...page_data,
            company_properties: [...(page_data.company_properties || []), property_data]
        });
    };


    const openCompRepModal = () => {
        setAddPropertiesModal(true);
    };

    return (
        <>
            <Head title={`Company Account Details - ${user_account}`} />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween className="g-3">
                        <BlockHeadContent>
                            <BlockTitle page>{`Company Account Details - ${user_account}`}</BlockTitle>
                            <BlockDes className="text-soft my-2 ">
                                <p>Company Details, Representative and Company Clients</p>
                            </BlockDes>
                            <Link to={`/dashboard/user/accounts`}>
                                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                                    <Icon name="arrow-left"></Icon>
                                    <span>Back</span>
                                </Button>
                            </Link>
                            <Link to={`/dashboard/user/accounts`}>
                                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                                    <Icon name="arrow-left"></Icon>
                                </Button>
                            </Link>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            {
                                !loading && (
                                    <>
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                            <Button
                                                className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                                                onClick={() => updateSm(!sm)}
                                            >
                                                <Icon name="menu-alt-r"></Icon>
                                            </Button>
                                            <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                                <ul className="nk-block-tools g-3">
                                                    <li className="preview-item">
                                                        <UncontrolledDropdown>
                                                            <div className="btn-group">
                                                                <DropdownToggle color="light" outline className="dropdown-toggle-split btn-white">
                                                                    <Icon name="chevron-down"></Icon>

                                                                    <span>Actions</span>
                                                                </DropdownToggle>
                                                            </div>
                                                            <DropdownMenu className="mt-3">
                                                                <ul className="link-list-opt">
                                                                    {findModuleAction(app_consts.ONBOARD_COMPANY, componentData) !== null && (
                                                                        <>
                                                                            <li>
                                                                                <DropdownItem
                                                                                    tag="a"
                                                                                    href="#"
                                                                                    onClick={(ev) => {
                                                                                        ev.preventDefault();
                                                                                        open_edit_company_details_modal();
                                                                                    }}
                                                                                >
                                                                                    <span>Edit Company Details</span>
                                                                                </DropdownItem>
                                                                            </li>
                                                                        </>
                                                                    )
                                                                    }
                                                                </ul>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    <Card>
                        <div className="card-aside-wrap" id="user-detail-block">
                            <div className="card-content">
                                <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} dataFetched={setDataFetched} />
                                {
                                    loading ?
                                        <>
                                            <AuthLoader loading_message="Loading Company Account Details..." />
                                        </>
                                        :
                                        <>
                                            {
                                                error && error.length > 0 ?
                                                    <>
                                                        <AuthError error_message={error} />
                                                    </>
                                                    :
                                                    <>
                                                        <div className="card-inner">
                                                            {
                                                                activeCardTab === "Main Details" && (
                                                                    <>
                                                                        <Block>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h5">Main Details</BlockTitle>
                                                                                <p>Names, Address, Contact Information and Documents</p>
                                                                            </BlockHead>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h6">Name and Contact Information</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="Company Name" text={page_data?.company_details?.company_name || "---"} />
                                                                                <ProfileDetailText label="Email Address" text={page_data?.company_details?.company_email_address || "---"} />
                                                                                <ProfileDetailText label="Mobile Number" text={page_data?.company_details?.company_mobile_number || "---"} />
                                                                                <ProfileDetailText label="Registration Number" text={page_data?.company_details?.pacra_registration_number || "---"} />
                                                                                <ProfileDetailText label="Tax Number" text={page_data?.company_details?.tax_number || "---"} />
                                                                                <ProfileDetailText label="Registration Date" text={page_data?.company_details?.inserted_at ? moment(page_data?.company_details?.inserted_at).format("MMMM Do, YYYY h:mm:ss") : "---"} />
                                                                            </div>
                                                                            <BlockHead className='mt-5'>
                                                                                <BlockTitle tag="h6">Documents</BlockTitle>
                                                                            </BlockHead>
                                                                            <Row className="g-gs w-100">
                                                                                <DocumentViewer lg={6} xxl={6} name="Registration Document" doc={page_data?.company_details?.company_pacra_doc} />
                                                                                <DocumentViewer lg={6} xxl={6} name="Tax Document" doc={page_data?.company_details?.company_tpin_doc} />
                                                                            </Row>
                                                                        </Block>
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                activeCardTab === "Main Contact Person" && (
                                                                    <>
                                                                        <Block>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h5">Main Contact Person</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="First Name" text={page_data?.main_access_account
                                                                                    ?.first_name || "---"} />
                                                                                <ProfileDetailText label="Middle Name" text={page_data?.main_access_account
                                                                                    ?.middle_name || "---"} />
                                                                                <ProfileDetailText label="Surname" text={page_data?.main_access_account
                                                                                    ?.surname || "---"} />
                                                                                <ProfileDetailText label="Email Address" text={page_data?.main_access_account
                                                                                    ?.email_address || "---"} />
                                                                                <ProfileDetailText label="Mobile Number" text={page_data?.main_access_account
                                                                                    ?.phone_number || "---"} />
                                                                            </div>
                                                                        </Block>
                                                                    </>
                                                                )
                                                            }
                                                        </div>

                                                        {findModuleAction(app_consts.ONBOARD_COMPANY, componentData) !== null && (
                                                            <>
                                                                <EditCompanyDetailsModal isOpen={edit_company_details_modal} cloasModal={close_edit_company_details_modal} successFunction={retrieve_user_account_details_func} data={page_data} />
                                                            </>
                                                        )
                                                        }




                                                    </>
                                            }
                                        </>
                                }
                            </div>
                        </div>
                    </Card>
                </Block>
            </Content>
        </>
    );
};

export default CompanyAccountDetails;
